import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import Cards from "./components/Cards";
import Body from "./components/Body";
import Footer from "./components/Footer";
import Callus from "./components/Callus";
import UpsCards from "./components/UpsCards";
import styles from "./styles/Home.module.css";

const Home = () => {
  return (
    <>
      <Navbar />
      <Banner />
      <UpsCards />
      <Cards />
      <Body />

      {/* بخش جدید درباره باتری با رعایت SEO */}
      <section className={styles.aboutSection}>
        <div className={styles.aboutContainer}>
          <h1 className={styles.aboutTitle}>
            درباره باتری{" "}
            <span
              style={{
                color: "#30c0e4",
              }}
            >
              ۱۰۰
            </span>
          </h1>
          <div className={styles.aboutContent}>
            <p>
              در{" "}
              <strong>
                باتری{" "}
                <span
                  style={{
                    color: "#30c0e4",
                  }}
                ></span>
              </strong>
              ، ما تضمین می‌کنیم که تمامی محصولات از جمله باتری‌های واریان، صبا
              و دیگر برندهای معتبر، دارای <strong>تاریخ تولید بروز</strong>
              هستند. کیفیت و اصالت کالاهای ما توسط{" "}
              <strong>گارنتی معتبر شرکتی</strong> تأیید می‌شود.
            </p>
            <ul className={styles.aboutList}>
              <li> تضمین اصالت و کیفیت تمامی باتری‌ها</li>
              <li> تاریخ تولید بروز و جدید</li>
              <li> گارنتی 12 ماهه برای باتری‌های واریان صبا</li>
              <li> پشتیبانی فنی و مشاوره تخصصی رایگان</li>
              <li> ارسال سریع به سراسر تهران</li>
            </ul>
            <p>
              ما در باتری۱۰۰ با تکیه بر سال‌ها تجربه در زمینه تأمین و توزیع
              باتری های یو پی اس و باتری های خودرو، این اطمینان را به شما
              می‌دهیم که محصولی باکیفیت و دارای گارنتی رسمی دریافت خواهید کرد.
              تمامی باتری‌های ما قبل از عرضه از نظر سلامت و عملکرد به دقت بررسی
              می‌شوند.
            </p>
            <h1
              style={{
                color: "#30c0e4",
                textAlign: "center",
              }}
            >
              راستی ارسال باتری های خودرو در باتری۱۰۰ رایگانه
            </h1>
          </div>
        </div>
      </section>

      <Callus />
      <Footer />
    </>
  );
};

export default Home;
